import { render, staticRenderFns } from "./RomfourInternalLocality.vue?vue&type=template&id=654592f2&"
import script from "./RomfourInternalLocality.vue?vue&type=script&lang=js&"
export * from "./RomfourInternalLocality.vue?vue&type=script&lang=js&"
import style0 from "./RomfourInternalLocality.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports